// extracted by mini-css-extract-plugin
module.exports = {"container":"src-components-ApkReclaim-ApkReclaim-module__container--1Ph8z","globalSave":"src-components-ApkReclaim-ApkReclaim-module__globalSave--U2-zw"};